'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _About = require('./About.css');

var _About2 = _interopRequireDefault(_About);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var About = (_dec = (0, _reactCssModules2.default)(_About2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About() {
    (0, _classCallCheck3.default)(this, About);
    return (0, _possibleConstructorReturn3.default)(this, (About.__proto__ || (0, _getPrototypeOf2.default)(About)).apply(this, arguments));
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      var title = 'About';
      var url = _config2.default.domain + _config2.default.routes.about;

      var bannerHeadline = 'Fossil Free Funds can help you avoid fossil fuel investments';
      // const bannerSubtitle = ''
      //
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, bannerHeadline, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-headline' },
              bannerHeadline
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'p',
              { styleName: 'lede' },
              _react2.default.createElement(
                'strong',
                null,
                'Fossil Free Funds'
              ),
              ' is a search platform built to help people find out if their money, in the form of individual investments or an employer-offered retirement plan, is being used to extract and consume fossil fuels.'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'lede' },
              _react2.default.createElement(
                'strong',
                null,
                'Owning investments in coal companies, oil/gas producers, and coal-fired utilities isn\u2019t just a moral question.'
              ),
              ' Fossil fuel investments carry real financial risks. When emissions are constrained, fossil fuel companies will have their carbon assets stranded. The implication is that they\u2019re massively overvalued, and markets are realizing that investing in fossil fuels is a risky bet.'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'lede' },
              _react2.default.createElement(
                'strong',
                null,
                'Fossil Free Funds'
              ),
              ' empowers investors to know exactly what they own, to see if their savings are invested in dirty energy sources, and to find investment options that support a cleaner, greener future.'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-401k-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-401k-info-photo' },
                _react2.default.createElement('div', {
                  styleName: 'x-401k-photo',
                  title: '401k retirement plans'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-401k-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-401k-info-title' },
                    'Retirement plans'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'For many of us, the majority of our investments are in 401(k)/403(b) plans offered by our employers. These plans invest entirely mostly through mutual funds and exchange-traded funds (ETFs). But those funds can invest in a wide array of securities, and it\u2019s not always easy for investors to investigate what\u2019s inside the funds they own. ',
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Your retirement money may be invested in economically and morally risky fossil fuel companies.'
                    )
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.toolkit,
                      title: 'Fossil free action toolkit'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'alink' },
                      'Check out our fossil free action toolkit',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-ays-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-ays-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-ays-info-photo' },
                _react2.default.createElement('div', {
                  styleName: 'x-ays-photo',
                  title: 'As You Sow'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-ays-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-ays-info-title' },
                    'As You Sow'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'At As You Sow, we\u2019ve been engaging energy companies on climate change issues for many years. When we decided to make sure our own 401k options were fossil free and socially responsible, we thought it would be simple. In fact, it took weeks of digging just to find out what was inside our plan. And what we found shocked us - oil companies, fossil-fired utilities, and other companies avoided by socially responsible investors. We decided it was time for people who aren\u2019t mutual fund experts to know how much of their retirement money was invested in unsustainable fossil fuel operations.'
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.ays,
                      title: 'As You Sow'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'alink' },
                      'Visit As You Sow',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-desktop-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-desktop-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-desktop-info-photo' },
                _react2.default.createElement('div', {
                  styleName: 'x-desktop-photo',
                  title: 'Your investments should align with your values'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-desktop-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-desktop-info-title' },
                    'How Fossil Free Funds works'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      'Look up mutual funds and exchange-traded funds (ETFs) using regularly-updated holdings data'
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      'Analyze your investments for fossil fuel stocks'
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      'See exposure to fossil finance and insurance, and clean energy leaders'
                    )
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.howitworks,
                      title: 'How it works | Fossil Free Funds'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'alink' },
                      'See how it works',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-desktop-info-title' },
                    'Use our action toolkit'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      'Learn how to make a change and invest fossil free'
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      'Ask your financial advisor about fossil free investing'
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      'Push your employer to provide fossil free options'
                    )
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.toolkit,
                      title: 'Fossil free action toolkit | Fossil Free Funds'
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'alink' },
                      'View the action toolkit',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-cu200-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-cu200-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-cu200-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-cu200-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-cu200-photo',
                    title: 'Carbon Underground 200'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-cu200-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-cu200-info-title' },
                      'Carbon Underground 200\u2122'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'The Carbon Underground 200\u2122, compiled and maintained by FFI Solutions, identifies the top 100 public coal companies globally and the top 100 public oil and gas companies globally, ranked by the potential carbon emissions content of their reported reserves.'
                    ),
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.carbonunderground200,
                        title: 'Carbon Underground 200'
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'alink' },
                        'More',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-macroclimate-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-macroclimate-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-macroclimate-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-macroclimate-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-macroclimate-photo',
                    title: 'Macroclimate 50'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-macroclimate-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-macroclimate-info-title' },
                      'Macroclimate',
                      _react2.default.createElement(
                        'small',
                        null,
                        _react2.default.createElement(
                          'sup',
                          null,
                          '\xAE'
                        )
                      ),
                      ' 50'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Coal is among the largest sources of global warming pollution in the world. Obtaining it destroys mountains, burning it releases hazardous emissions, and disposing of it results in hazardous toxic waste. Coal is scorching the planet and leaving a legacy of devastation in its wake. We partnered with Macroclimate',
                      _react2.default.createElement(
                        'small',
                        null,
                        _react2.default.createElement(
                          'sup',
                          null,
                          '\xAE'
                        )
                      ),
                      ' to screen mutual funds for the Macroclimate',
                      _react2.default.createElement(
                        'small',
                        null,
                        _react2.default.createElement(
                          'sup',
                          null,
                          '\xAE'
                        )
                      ),
                      ' 50 \u2013 an exclusion list of the 50 largest public-company owners of coal-fired power plants in Developed Markets plus China and India.'
                    ),
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.macroclimate50,
                        title: 'Macroclimate 50'
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'alink' },
                        'More',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-morningstar-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-morningstar-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-morningstar-container-inner' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.morningstar,
                    title: 'Morningstar'
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-morningstar-info-photo' },
                    _react2.default.createElement('div', {
                      styleName: 'x-morningstar-photo',
                      title: 'Morningstar'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-morningstar-info' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'x-morningstar-info-title' },
                        'Morningstar investment research'
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        'Morningstar, Inc. is a leading provider of independent investment research. They provide the financial data on global stocks and U.S. mutual funds, including company industry classifications, that we use to power Fossil Free Funds.'
                      ),
                      _react2.default.createElement(
                        'div',
                        { styleName: 'alink' },
                        'More',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-clean200-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-clean200-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-clean200-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-clean200-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-clean200-photo',
                    title: 'Clean200'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-clean200-info' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'x-clean200-info-title' },
                      'Clean200'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Over the past years, a growing movement of investors representing trillions of dollars in assets under management have divested some portion of their fossil fuel investments. But where to invest this capital? The corollary of divesting fossil fuels is re-investing in the clean energy future. As an invitation to a larger discussion of how we can invest in this future, As You Sow and Corporate Knights created the ',
                      _react2.default.createElement(
                        'strong',
                        null,
                        'Carbon Clean 200'
                      ),
                      ' \u2014 a list of 200 publicly traded companies that are leading the way with solutions for the transition to clean energy.'
                    ),
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.clean200,
                        title: 'Clean200'
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'alink' },
                        'More',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return About;
}(_react.Component)) || _class);
exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1392
// module chunks = 0